<template>
  <div class="folders-listing">
    <vx-card :title="$t('labels.folders_by_vessel_type')" class="lead-listing">
      <div class="vx-row w-full m-0 list-header">
        <div
          class="vx-col sm: w-1/2 md:w-1/2 mb-4 set_limit pl-0 pr-0 justify-between"
        >
          <div class="set flex">
            <label class="limit_label">{{ $t("labels.show") }}</label>
            <v-select
              v-model="limit"
              :options="limitarr"
              :reduce="(limitarr) => limitarr.value"
              :clearable="false"
              label="text"
              class="px-1"
            />
            <label class="limit_label">{{ $t("labels.folders") }}</label>
          </div>
        </div>
      </div>

      <vs-table :data="folders" class="permission">
        <template slot="thead">
          <vs-th class="col-md-2">{{ $t("labels.vessel_type") }}</vs-th>
          <vs-th class="col-md-4">{{ $t("labels.vessel_sub_type") }}</vs-th>
          <vs-th class="col-md-4">{{ $t("labels.section_count") }}</vs-th>
          <vs-th class="col-md-3">{{ $t("labels.action") }}</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>{{ tr.vessel_type.parent.name }} </vs-td>
            <vs-td>{{ tr.vessel_type ? tr.vessel_type.name : "-" }}</vs-td>
            <vs-td>{{ tr.folder_count }}</vs-td>
            <vs-td width="125">
              <div class="flex">
                <vs-button
                  type="flat"
                  :title="$t('labels.view')"
                  size="large"
                  icon-pack="feather"
                  icon="icon-folder"
                  color="#17a2b8"
                  class="mr-2"
                  v-if="checkPermission('folders', 'view')"
                  @click="
                    $router.push({
                      name: 'ListSection',
                      params: {
                        vessel_type_id: tr.vessel_type.parent.id,
                        vessel_sub_type_id: tr.vessel_type.id,
                      },
                    })
                  "
                ></vs-button>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <div class="mt-6">
        <vs-pagination
          color="dark"
          :total="totalPage"
          v-model="currentx"
          class="mb-1"
        ></vs-pagination>
      </div>
    </vx-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      folders: [],
      index: -1,
      totalPage: 1,
      currentx: 1,
      // limit: this.$store.state.limit,
      limit: parseInt(process.env.VUE_APP_PER_PAGE),
      search: null,
    };
  },
  watch: {
    limit(val) {
      localStorage.setItem("limit", val);
      this.currentx = 1;
      this.getFolders();
    },
    currentx(val) {
      this.getFolders();
    },
  },
  mounted() {
    if (localStorage.getItem("limit")) {
      this.limit = localStorage.getItem("limit");
    }
    this.getFolders();
  },
  methods: {
    openFilter() {
      this.getfilterVesselTypes();
    },
    deleteConfirm(index) {
      this.index = index;
      let text = this.$t("strings.delete_confirm");
      this.$vs.dialog({
        type: "confirm",
        color: "rgba(var(--vs-primary),1)",
        title: this.$t("labels.confirmation"),
        acceptText: this.$t("labels.yes"),
        cancelText: this.$t("labels.no"),
        text: text,
        accept: this.deleteFolder,
      });
    },
    async deleteFolder() {
      if (this.index < 0) return;
      let url = "folders/delete";
      let ids = [];
      let index = this.index;
      ids.push(this.folders[index].id);
      let input = {
        ids: ids,
      };
      let response = await this.getHTTPPostResponse(url, input, null, true);
      if (response) {
        this.getFolders();
      }
    },
    async getFolders() {
      let input = {
        page: this.currentx,
        perPage: this.limit,
      };

      let response = await this.getHTTPPostResponse(
        "/folders/subfolder/grouped/v2",
        input
      );

      if (response) {
        let data = response.data;
        this.folders = [];
        let perPage = this.limit;
        let totalPage = Math.ceil(response.data.count / perPage);
        this.totalPage = totalPage;
        data.vesselType.map((parent) => {
          this.folders.push(parent);
        });
      }
    },
  },
};
</script>
